// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "-" + {"285":"665e9303","699":"3ec096d1"}[chunkId] + ".css";
};